import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {EvkSecurityControlDataService} from '@evomatik/evk-seguridad';
import {EvkHttpService, EvkUpdateServiceBase} from '@evomatik/evk-common';
import {TareaDocumentoModel} from "../../../../../../../diligencia/models/tarea-documento.model";
import {DiligenciaTareaModel} from "../../../../../../../diligencia/models/diligencia-tarea.model";

@Injectable({
    providedIn: 'root'
})
export class TurnarDiligenciaService extends EvkUpdateServiceBase<any> {

    public get api(): string {
        return '/seaged-diligencias-service/diligencia/v2/turnar';
    }

    constructor(http: EvkHttpService, public evkSecurity: EvkSecurityControlDataService) {
        super(http);
    }

    evkOnDoneEdit(response) {
    }

    evkOnErrorEdit(response) {
    }

    evkOnBeforeEdit(data: TareaDocumentoModel): Observable<any> {
        return new Observable(observer => {
            const diligencia = new DiligenciaTareaModel();
            diligencia['id'] = data.idNegocio;
            diligencia['idDiligenciaConfig'] = data.detalle.idDiligenciaConfig;
            diligencia['usuarioDestino'] = data.usuarioAsignado;
            diligencia['unidadDestino'] = data.organizacion;
            diligencia['usuarioOrigen'] = {
                label: this.evkSecurity.getUsuarioInfo().nombreCompleto,
                value: this.evkSecurity.getUsuarioInfo().username
            };
            observer.next(diligencia);
        });
    }
}
